import { createSlice } from '@reduxjs/toolkit';
const initialState = false;
const isOnSearchModeSlice = createSlice({
  name: 'isSearchModeOn',
  initialState,
  reducers: {
    updateIsOnSearchMode: (__, action) => {
      return action.payload;
    }
  }
});
export const {
  updateIsOnSearchMode
} = isOnSearchModeSlice.actions;
export default isOnSearchModeSlice.reducer;